const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "512px",
    viewBox: "-68 0 511 512",
    width: "512px",
    className: "hovered-paths",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m34.632812 512h307.199219c18.851563 0 34.132813-15.28125 34.132813-34.132812v-375.46875h-85.332032c-9.425781 0-17.066406-7.640626-17.066406-17.066407v-85.332031h-238.933594c-18.851562 0-34.132812 15.28125-34.132812 34.132812v443.734376c0 18.851562 15.28125 34.132812 34.132812 34.132812zm0 0",
    fill: "#d8d7da",
    "data-original": "#D8D7DA",
    className: "hovered-path active-path",
    style: {
      fill: "#17D092"
    },
    "data-old_color": "#d8d7da"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.632812 102.398438h85.332032l-102.398438-102.398438v85.332031c0 9.425781 7.640625 17.066407 17.066406 17.066407zm0 0",
    fill: "#939598",
    "data-original": "#939598",
    className: "",
    style: {
      fill: "#17D092"
    },
    "data-old_color": "#939598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.9aee725ef44089a44de3351b19f5b890.svg";
export { ForwardRef as ReactComponent };